import { render, staticRenderFns } from "./Haberler.vue?vue&type=template&id=336353d0&scoped=true&"
import script from "./Haberler.vue?vue&type=script&lang=js&"
export * from "./Haberler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336353d0",
  null
  
)

export default component.exports